export const state = {
    files: [],
    loadedFiles: [],
    response: '',
}; 